import { type VFC } from 'react'

import { isCdnUrl } from 'shared/utils/imageUtils'
import CdnImage from 'views/components/atoms/CdnImage'
import Image from 'views/components/atoms/Image'
import { usePublicConfig } from 'views/utils/shopAndRuntimeConfigUtils'

type CompactProductListItemImageProps = {
  alt: string
  className?: string
  src: string
}

const IMAGE_SIZE = 100

const CompactProductListItemImage: VFC<
  CompactProductListItemImageProps
> = props => {
  const { alt, className, src } = props

  const publicConfig = usePublicConfig()

  if (isCdnUrl(publicConfig, src)) {
    return (
      <CdnImage
        alt={alt}
        fileName={src}
        lazyLoad
        maxHeight={IMAGE_SIZE}
        maxWidth={IMAGE_SIZE}
        minWidth={IMAGE_SIZE}
        wrapperClassName={className}
      />
    )
  }

  return (
    <Image
      alt={alt}
      className={className}
      lazyLoad
      src={src}
      srcHeight={IMAGE_SIZE}
      srcWidth={IMAGE_SIZE}
    />
  )
}

export default CompactProductListItemImage
